// Copyright (c) Jupyter Development Team.
// Distributed under the terms of the Modified BSD License.
import { provideJupyterDesignSystem, jpSlider } from '@jupyter/web-components';
import { provideReactWrapper } from '@microsoft/fast-react-wrapper';
import React from 'react';
const { wrap } = provideReactWrapper(React, provideJupyterDesignSystem());
export const Slider = wrap(jpSlider(), { events: { onChange: 'change' } });
// @ts-expect-error unknown property
Slider.displayName = 'Jupyter.Slider';
